<template>
  <v-dialog :model-value="dialog" width="auto">
    <v-card
      flat
      width="500"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
      }"
    >
      <v-sheet
        class="d-flex justify-center align-center py-2"
        color="accent"
        style="font-size: 10pt; font-weight: 600"
      >
        Add LinkedIn Accounts
      </v-sheet>
      <v-divider class="primary"></v-divider>
      <div class="pa-4" v-if="accounts.length > 0">
        <p style="font-size: 10pt">Select the organization you want to add:</p>
        <div v-for="(a, i) in accounts" :key="a.id">
          <div
            class="align-center"
            style="display: grid; grid-template-columns: 50px auto"
          >
            <v-checkbox
              @click="selectAccount(a.id)"
              :model-value="a.selected"
              hide-details=""
            ></v-checkbox>
            <div class="d-flex align-center">
              <v-avatar
                size="25"
                class="mr-4"
                v-if="a.profile_picture"
                :image="a.profile_picture"
              ></v-avatar>
              <v-avatar
                size="25"
                class="mr-4"
                style="font-size: 10pt"
                color="primary"
                v-else
                >{{ a.name.charAt(0) }}</v-avatar
              >
              <span style="font-size: 13pt; font-weight: 400">{{
                a.name
              }}</span>
            </div>
          </div>
          <v-divider v-if="i < accounts.length - 1"></v-divider>
        </div>
      </div>
      <div class="pa-4" v-else>
        <p style="font-size: 10pt">
          You don't have any organizations connected to your LinkedIn account
          where you are admin.
        </p>
      </div>
      <v-divider></v-divider>
      <template v-slot:actions>
        <v-btn text="Close" @click="$emit('close')"></v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text="Add"
          variant="flat"
          @click="$emit('add')"
          color="success"
        ></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      default: false,
    },
    accounts: {
      default: [],
    },
  },
  methods: {
    selectAccount(id) {
      this.accounts.map((a) => {
        if (a.id !== id) {
          a.selected = false;
        } else {
          a.selected = true;
        }
      });
    },
  },
};
</script>
